module.exports = __webpack_public_path__ + "img/hr-H-T-6-unload-standup-shadow.a74389b6.png";